import { connectColors } from '@/theme/colors';
import { Button } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';

type Props = {
  count: number;
  onClear: () => void;
};

/**
 * Same look as the shared FilterStatus, but with a count of filters that have a condition.
 * FilterStatus counts every column filter in the table state, which includes empty date ranges.
 */
export const ActiveFilterStatus = ({ count, onClear }: Props) => {
  if (count === 0) {
    return (
      <Text
        className="label-sm-medium"
        color={connectColors.core.slate[900]}
        whiteSpace="nowrap"
      >
        No filters applied
      </Text>
    );
  }

  return (
    <Flex gap="4px" alignItems="center">
      <Text
        className="label-sm-medium"
        color={connectColors.core.slate[900]}
        whiteSpace="nowrap"
      >
        {count} {count === 1 ? 'filter' : 'filters'} applied
      </Text>
      <Button
        appearance="ghost"
        size="small"
        onClick={onClear}
        iconName="control-close"
      >
        Clear all filters
      </Button>
    </Flex>
  );
};
